import React, { useEffect, useState } from 'react';
import { fetchPaymentProofs, fetchSubscriptions } from '../../services/accountService'; 
import './AccountHistoryPage.css'; 

const AccountHistoryPage = () => {
    const [paymentProofs, setPaymentProofs] = useState([]);
    const [subscriptions, setSubscriptions] = useState([]);
    const [loadingProofs, setLoadingProofs] = useState(true);
    const [loadingSubs, setLoadingSubs] = useState(true);
    const [errorProofs, setErrorProofs] = useState(null);
    const [errorSubs, setErrorSubs] = useState(null);

    useEffect(() => {
        const getHistory = async () => {
            try {
                const proofsData = await fetchPaymentProofs();
                setPaymentProofs(proofsData);
                setLoadingProofs(false);
            } catch (error) {
                setErrorProofs('Failed to load payment proof history.');
                setLoadingProofs(false);
            }

            try {
                const subsData = await fetchSubscriptions();
                setSubscriptions(subsData);
                setLoadingSubs(false);
            } catch (error) {
                setErrorSubs('Failed to load subscription history.');
                setLoadingSubs(false);
            }
        };

        getHistory();
    }, []);

    return (
        <div className="history-page-container">
            <h1>Your Account History</h1>

            <section className="payment-proofs-section">
                <h2>Payment Proof Submissions</h2>
                {loadingProofs ? (
                    <p>Loading payment proofs...</p>
                ) : errorProofs ? (
                    <p className="error-message">{errorProofs}</p>
                ) : paymentProofs.length === 0 ? (
                    <p>No payment proofs submitted yet.</p>
                ) : (
                    <div className="proofs-grid">
                        {paymentProofs.map(proof => (
                            <div key={proof.id} className="proof-card">
                                <h3>Proof ID: #{proof.id}</h3>
                                <p><strong>Amount:</strong> {proof.amount} {proof.currency}</p>
                                <p><strong>Bank:</strong> {proof.bank_name}</p>
                                <p><strong>Submitted:</strong> {new Date(proof.submitted_at).toLocaleDateString()}</p>
                                <p className={proof.is_verified ? 'verified-status' : 'pending-status'}>
                                    <strong>Status:</strong> {proof.is_verified ? 'Verified' : 'Pending'}
                                </p>
                                {proof.proof_image_url && (
                                    <a href={proof.proof_image_url} target="_blank" rel="noopener noreferrer">View Proof Image</a>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </section>

            <section className="subscriptions-section">
                <h2>Your Subscriptions</h2>
                {loadingSubs ? (
                    <p>Loading subscriptions...</p>
                ) : errorSubs ? (
                    <p className="error-message">{errorSubs}</p>
                ) : subscriptions.length === 0 ? (
                    <p>No subscriptions found yet.</p>
                ) : (
                    <div className="subscriptions-list">
                        {subscriptions.map(sub => (
                            <div key={sub.id} className="subscription-item">
                                <h3>{sub.plan} Plan</h3>
                                <p><strong>From:</strong> {new Date(sub.start_date).toLocaleDateString()}</p>
                                <p><strong>To:</strong> {sub.end_date ? new Date(sub.end_date).toLocaleDateString() : 'Indefinite'}</p>
                                <p className={sub.is_premium_active ? 'active-sub' : 'inactive-sub'}>
                                    <strong>Status:</strong> {sub.is_premium_active ? 'Active Premium' : 'Inactive'}
                                </p>
                                {!sub.is_premium_active && sub.plan === 'Premium' && sub.end_date && new Date(sub.end_date) < new Date() && (
                                    <p className="expired-text">(Expired)</p>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </section>
        </div>
    );
};

export default AccountHistoryPage;